<div class="page-wrapper">
  <router-outlet></router-outlet>
</div>
